import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { Terminology } from '../models/terminology';
import type { TerminologyOverrides } from '../types/interfaces/terminology';

export class TerminologyService extends BaseService<Terminology> {
  override model = Terminology;

  override modelName = 'terminology';
  override modelLabel = 'Terminology';

  async terminology(): Promise<ApiResponse<Terminology>> {
    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl,
    });

    return await this.requestItem<Terminology>(request, Terminology);
  }

  async saveTerminology(terms: TerminologyOverrides): Promise<ApiResponse<Terminology>> {
    const request = new ApiRequest({
      method: 'POST',
      url: this.modelBaseUrl,
      data: { terminology: terms },
    });

    return await this.requestItem<Terminology>(request, Terminology);
  }
}
